import { render, staticRenderFns } from "./SfSteps.vue?vue&type=template&id=6abc2120&"
import script from "./SfSteps.vue?vue&type=script&lang=js&"
export * from "./SfSteps.vue?vue&type=script&lang=js&"
import style0 from "./SfSteps.vue?vue&type=style&index=0&id=6abc2120&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports